// put variables and collections here
export default {
  username: null, // string
  user: {} // user: object
}



// WEBPACK FOOTER //
// ./src/store/state.js